module.exports = __webpack_public_path__ + "static/ebr-11-39a7b7697e3950e7642daabfe8aa7b7f.jpg";